'use client';

import React, { useEffect, useState } from 'react';

import { WelcomeCard } from '@/components/WelcomeCard';
import { useUserInfo } from '@/context/UserInfoContext';

const HomeWelcomeSection: React.FC = () => {
  const { userInfo, reloadUserInfo } = useUserInfo();
  const [showWelcomeCard, setShowWelcomeCard] = useState(false);

  useEffect(() => {
    setShowWelcomeCard(userInfo ? !userInfo.has_been_welcomed : false);
  }, [userInfo]);

  if (!showWelcomeCard) {
    return null;
  }

  return (
    <WelcomeCard
      onDismiss={() => {
        setShowWelcomeCard(false);
        reloadUserInfo(); // Reload user info to update has_been_welcomed status
      }}
    />
  );
};

export default HomeWelcomeSection;
